import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, KImageURL, DefaultImage } from "../GlobalScript";
import Cookies from 'js-cookie';
import ReactPaginate from 'react-paginate';
import PulseLoader from "react-spinners/PulseLoader";
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer';
import { ShoppingCartContext } from '../dealer/ShoppingCartContext';
import Select from 'react-select'
//import useLocalStorage from "use-local-storage";

export default function InventoryList() {

    const navigate = useNavigate();
    const itemsPerPage = 10;
    const [Items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    //const [status, setStatus] = useState('');
    const [Year, setYear] = useState(null);
/*    const [YearTo, setYearTo] = useState('');*/
    const [activeRow, setActiveRow] = useState(null);
    const dropdownRef = useRef(null);
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    /*const currentItems = orderItems.slice(itemOffset, endOffset);*/
    const pageCount = Math.ceil(Items.length / itemsPerPage);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const currentItems = Items.slice(itemOffset, endOffset);
    const historyType = 'order';
    const location = useLocation();
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [CategoryList, setCategoryList] = useState(null);
    const [Category, setCategory] = useState(null);
    const [Model, setModel] = useState(null);
    const [ModelList, setModelList] = useState(null);
    const [YearList, setYearList] = useState(null);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    const [pop, setPop] = useState(false);
    const [searchSession, setSearchSession] = useState(() => {
        const data = localStorage.getItem('inventorySrch');
        return data ? JSON.parse(data) : null;
    });
    const [preLoadSession, setPreLoadSession] = useState(false);
    useEffect(() => {
        setShoppingCart(GetShoppingCart());
        document.title = 'K-Dealer - Inventory Admin';

    });

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const handleDetailsModalShow = async (id) => {
        //await GetItemDetail(order);
        //setShowDetailsModal(true);
        navigate('/catalog/itemedit', { state: { id: id } });
    }
    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
        setSelectedOrder(null);
        if (location.state) {
            window.history.replaceState({}, '')
        }
    }


    //useEffect(() => {
    //    if (preLoadSession === true) {
    //        handleSearchClick();
    //        setPreLoadSession(false);
    //    }
    //}, [keyword, Year, Category, Model])

    useEffect(() => {
        if (searchSession) {
            setKeyword(searchSession.keyword);
            //setYear(searchSession.year && searchSession.year.length > 0 ? searchSession.year : null);
            setCategory(searchSession.category && searchSession.category.length > 0 ? searchSession.category : null);
            //setModel(searchSession.model && searchSession.model.length > 0 ? searchSession.model : null);
            setPreLoadSession(true);
        }
    }, [searchSession])
   
    useEffect(() => {
        if (Category && Category.length > 0) {
            LoadYearList();
            if (preLoadSession) {
                setYear(searchSession && searchSession.year && searchSession.year.length > 0 ? searchSession.year : null);
                setModel(searchSession && searchSession.model && searchSession.model.length > 0 ? searchSession.model : null);
            }
        }
        else {
            setYearList(null);
            setYear(null);
            setModel(null);
        }
       
    }, [Category]);
    useEffect(() => {
        if (!CategoryList) {
            LoadCategoryList();
        }
    }, [CategoryList]);

    useEffect(() => {
        if (Year && Year.length > 0 && Category && Category.length > 0) {
            LoadModelList();
            if (preLoadSession) {
                setModel(searchSession && searchSession.model && searchSession.model.length > 0 ? searchSession.model : null);
                handleSearchClick();
            }
            setPreLoadSession(false);
        }
        else {
            setModel(null);
            setModelList(null);
        }
    }, [Year]);

    const ResetSearch = async () => {
        setKeyword('');
        //setStatus('');
        setYear(null);
        setCategory(null);
        setLoading(true);
        localStorage.setItem('inventorySrch', null);
    }

    const LoadCategoryList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch("inventory/GetCategoryList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setCategoryList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const LoadYearList = async () => {
        try {
            CheckSession();
            handlePop();
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(Category.map(obj => obj.value))
            };
            const response = await fetch('inventory/GetYearList/', rqst);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setYearList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const LoadModelList = async () => {
        try {
            if (!Year || Year.length === 0 || !Category || Category.length === 0) {
                return;
            }
            handlePop();
            const data = {
                categoreis: Category.map(obj => obj.value),
                years: Year.map(obj => obj.value)
            }
            CheckSession();
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('inventory/GetModelList/', rqst);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setModelList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const GetItems = async (orderby, inc) => {
        try {
            CheckSession();
            if ((!keyword || keyword.trim() === '') && !Year && !Model && !Category) {
                handleClosePop();
                return;
            }
            const data = {
                keyword: keyword.trim(),
                year: Year?Year.map(obj => obj.value) : [],
                orderBy: orderby,
                inc: inc,
                model: Model? Model.map(obj => obj.value) : [],
                category: Category? Category.map(obj => obj.value): [],
            }
            const serchData = {
                keyword: keyword.trim(),
                year: Year,
                model: Model,
                category: Category,
            }
            localStorage.setItem('inventorySrch', JSON.stringify(serchData));
            if (data.keyword === '' && data.year.length === 0 && data.model.length === 0 && data.category.length === 0) {
                handleClosePop();
                return;
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("inventory/GetItems", requestOptions);
            if (response.status !== 200) {
                setItems(null);
                handleClosePop();
                return;
            }
            const res = await response.json();
            setItems(res);
            handleClosePop();
            console.log(res)
        }
        catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'category') {
            setCategoryList(value);
        }
    }

    const handleSearchClick = async () => {
        try {
            handlePop();
            GetItems('', true);
        }
        catch (e) {
            handleClosePop();
            console.log(e);
        }
    };

    const handleReturnClick = (e, orderID) => {
        try {
            navigate('/creditrequest', { state: { id: orderID } });
        }
        catch (e) {
            console.log(e);
        }
    };

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % Items.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };

    const handleChangeCategory = (selected) => {
        setCategory(selected);
    };
    const handleChangeModel = (selected) => {
        setModel(selected);
    };
    const handleChangeYear = (selected) => {
        setYear(selected);
    };

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">Inventory Admin</h1>
                    </Col>
                    <Col className="checkout-title-under"></Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col sm={3}>
                                        <FloatingLabel label="Keyword" className="mb-4">
                                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        {CategoryList && <Select
                                            placeholder={<div>Category</div>}
                                            isMulti
                                            options={CategoryList}
                                            value={Category}
                                            onChange={handleChangeCategory}
                                            className="mt-2"
                                        />}
                                    </Col>
                                    <Col sm={3}>
                                        {YearList && <Select
                                            placeholder={<div>Year</div>}
                                            isMulti
                                            options={YearList}
                                            value={Year}
                                            onChange={handleChangeYear}
                                            className="mt-2"
                                        />}
                                    </Col>
                                    <Col sm={3}>
                                        {ModelList && ModelList.length > 0 && <Select
                                            placeholder={<div>Model</div>}
                                            isMulti
                                            options={ModelList}
                                            value={Model}
                                            onChange={handleChangeModel}
                                            className="mt-2"
                                        />}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={{ offset: 8 }} className="text-right" style={{ alignSelf: 'center' }}>
                                        <p className="clickable underline green-text" onClick={ResetSearch}>Reset Search</p>
                                    </Col>
                                    <Col className="text-center mb-3">
                                        <Button variant="secondary" onClick={handleSearchClick}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            SEARCH
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {currentItems && currentItems.length > 0 && <Row className="mt-5 mb-5">
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row className="table-legend text-center">
                                    <Col sm={12}>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>
                                            <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>
                                            <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>
                                        </div>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                            <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                            <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                        </div>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="next >"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        previousLabel="< previous"
                                        renderOnZeroPageCount={null}
                                        containerClassName="table-navigation"
                                        previousLinkClassName="table-nav-link"
                                        nextLinkClassName="table-nav-link"
                                    />
                                </Row>
                                <Row>
                                    <Col sm={12} className="order-table">
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Image</th>
                                                    <th>Item Number</th>
                                                    <th>Item Name</th>
                                                    <th>Category</th>
                                                    <th>Model(s)</th>
                                                    <th>Year(s)</th>
                                                    <th>Status</th>
                                                    <th width="10%"></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {currentItems && currentItems.map((item, index) => (
                                                    <tr className="" key={item.refID}>
                                                        <td>{index + 1}</td>
                                                        <td className="table-img">
                                                            <img src={KImageURL(item.itemNumber, item.imgName)}
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = DefaultImage;
                                                                }}
                                                                alt="Product" className="item-image"></img>
                                                        </td>
                                                        <td>{item.itemNumber}</td>
                                                        <td>{item.itemDescription}</td>
                                                        <td>{item.categoryName}</td>
                                                        <td>{item.modelMarketingNames}</td>
                                                        <td>{item.modelYear}</td>
                                                        <td></td>
                                                        <td className="table-row" ref={dropdownRef} style={{ position: activeRow === item.itemNumber ? 'absolute' : 'static' }}>
                                                            <span className="underline" onClick={() => handleDetailsModalShow(item.itemNumber)}>Edit</span>
                                                            {/*<InputGroup className="">*/}
                                                            {/*    <DropdownButton*/}
                                                            {/*        variant="outline-secondary"*/}
                                                            {/*        title=""*/}
                                                            {/*        id="input-group-dropdown-1"*/}
                                                            {/*    >*/}
                                                            {/*        <Dropdown.Item><span className="bold">Duplicate Order</span></Dropdown.Item>*/}
                                                            {/*        {item.exchangable && <Dropdown.Item><span className="bold">Exchange</span></Dropdown.Item>}*/}
                                                            {/*        {item.returnable && <Dropdown.Item onClick={(e) => handleReturnClick(e, item.orderID)}><span className="bold">Return</span></Dropdown.Item>}*/}
                                                            {/*        <Dropdown.Item><span className="bold">Cancel Backorder</span></Dropdown.Item>*/}
                                                            {/*    </DropdownButton>*/}
                                                            {/*</InputGroup>*/}
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>}              

            </Container>

            <FooterDealer />

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>
        </>
    );
}